const errorMessage = (errorcode, error) => {

    const message = {
        ogImageError: "يرجى تحميل صورة OG",
        notUpdated: "لم يتم التحديث",
        notLoggedIn: "غير مسجل الدخول",
        optionUnavailable: "هذا الخيار لم يعد متاحًا.",
        unknownOption: "الخيار المحدد غير موجود.",
        duplicateOption: "تم اختيار خيار أكثر من مرة.",
        invalidBillingMode: "طريقة فوترة الخيار غير صالحة.",
        deliveryLocationRequired: "الرجاء إدخال موقع التسليم (5 أحرف على الأقل).",
        deliveryLocationTooLong: "موقع التسليم طويل جدًا (255 حرفًا كحد أقصى).",
        invalidDays: "مدة الإيجار غير صالحة.",
        bookingTotalMismatch: "تغيّر مبلغ الحجز. يرجى مراجعة الإجمالي الجديد والمحاولة مرة أخرى.",
        optionDisabledByAdmin: "تم تعطيل هذه الخدمة من قبل GOZY.",
        invalidOptionSlot: "خيار غير صالح.",
        maxOptionsReached: "لقد بلغت الحد الأقصى لعدد الخيارات المخصصة.",
        invalidOptionPrice: "أدخل سعرًا صالحًا أكبر من 0 للخيار النشط.",
        invalidOptionLabel: "يجب أن يتراوح اسم الخيار بين 3 و40 حرفًا.",
        reservedOptionLabel: "هذا الاسم محجوز لخدمة مدمجة.",
        optionLabelTaken: "لديك بالفعل خيار بهذا الاسم.",
        invalidOptionDescription: "يجب ألا يتجاوز الوصف 140 حرفًا.",
        optionNotFound: "الخيار غير موجود.",
        notListingOwner: "يمكنك إدارة خيارات إعلاناتك فقط.",
        listingNotAvailable: "القائمة غير متاحة",
        notAvailable: "غير متوفر",
        updateStatusError: "عفواً! تعذّر تحديث الحالة. يُرجى المحاولة مرة أخرى.",
        loginError: "عفواً! الرجاء تسجيل الدخول والمتابعة.",
        createReservationError: "فشل في إنشاء الحجز.",
        createPayoutError: "فشل في إنشاء الدفعة.",
        deleteRecordError: "خطأ في حذف السجل.",
        commonError: error ? error : "عفواً! حدث خطأ ما. يُرجى المحاولة مرة أخرى.",
        adminRoleError: "عذراً، لم أتمكن من العثور على دور المسؤول هذا.",
        deleteAdminRoleError: "عفواً! تعذر حذف دور المسؤول بسبب استخدام أحد المستخدمين لهذا الدور.",
        invalidAdminRole: "عفواً، يبدو أن الدور الذي اخترته غير صالح. يُرجى محاولة اختيار دور صالح آخر.",
        checkEmail: "عفواً! هذا عنوان البريد الإلكتروني موجود بالفعل.",
        noDocumentsFound: "لم يتم العثور على أي مستندات. يُرجى المحاولة مرة أخرى.",
        userLoginAccount: "عفواً! يُرجى تسجيل الدخول بحسابك والمحاولة مرة أخرى.",
        updateReviewError: "حدث خطأ ما! تعذّر تحديث المراجعة. يُرجى المحاولة لاحقًا.",
        somethingWrong: "حدث خطأ ما. يُرجى المحاولة مرة أخرى.",
        invalidRequest: "طلب غير صالح",
        chooseOption: "يجب أن يكون هناك خيار واحد على الأقل نشطًا.",
        noRecord: "حدث خطأ! لم يتم العثور على أي سجلات. يُرجى المحاولة مرة أخرى.",
        userLogin: "حدث خطأ ما! يُرجى تسجيل الدخول والمحاولة مرة أخرى.",
        findActiveReservation: "عفواً! تعذر حذف هذا المستخدم. يبدو أن لديه حجوزات نشطة/مستقبلية، وعليه إلغاءها أو إكمالها ليتمكن من حذفها.",
        createThreadItemFailed: "فشل في إنشاء عناصر الموضوع.",
        createThreadFailed: "فشل في إنشاء موضوع.",
        checkUserExist: "عفواً! المستخدم مختلف.",
        adminLogin: "يرجى تسجيل الدخول كمستخدم مسؤول ثم حاول مرة أخرى.",
        noRecordFound: "لم يتم العثور على أي سجل.",
        fetchRecordsError: "حدث خطأ أثناء جلب السجلات. يرجى المحاولة مرة أخرى.",
        userLoggedIn: "لم يتم تسجيل دخولك. يرجى تسجيل الدخول والمحاولة مرة أخرى.",
        checkListSettings: "عفواً! تعذر العثور على إعدادات القائمة. يُرجى المحاولة مرة أخرى.",
        userNotLoggedIn: "المستخدم غير مسجل الدخول",
        userLoginError: "عفواً! الرجاء تسجيل الدخول والمتابعة.",
        wrongConfirmPassword: "تأكيد كلمة المرور الخاطئة",
        wrongPassword: "كلمة مرور خاطئة",
        updateFailed: "فشل التحديث",
        userLoginExist: "الرجاء تسجيل الدخول بحسابك",
        invalidError: "لقد حدث خطأ ما",
        checkUserLogin: "الرجاء تسجيل الدخول",
        userBan: "تم حظر المستخدم",
        adminLoginError: "يرجى تسجيل الدخول كمسؤول ثم المحاولة مرة أخرى",
        unableToProceed: "عفواً! تعذر إكمال الإجراء المطلوب. يُرجى المحاولة مرة أخرى.",
        errorLogin: "الرجاء تسجيل الدخول والاستمرار",
        userNotExist: "لا يوجد مستخدم موجود",
        userExist: "مستخدم موجود",
        userUnBan: "المستخدم غير محظور",
        userNotDeleted: "المستخدم غير محذوف",
        userDeleted: "تم حذف المستخدم",
        adminLoggedIn: "adminLoggedIn",
        login: "تم تسجيل الدخول",
        unknownError: "عذرًا، حدث خطأ ما. يُرجى المحاولة مرة أخرى.",
        success: "نجاح",
        error: "خطأ!",
        warning: "تحذير!",
        forgotPassword: "لا يوجد حساب مرتبط بعنوان البريد الإلكتروني المقدم.",
        tryAgain: "حدث خطأ ما، يرجى المحاولة مرة أخرى لاحقًا",
        resetPasswordLink: "لقد أرسلنا رابط إعادة تعيين كلمة المرور إلى بريدك الإلكتروني. يُرجى مراجعة بريدك الوارد!",
        contactHost: "لقد تم إرسال طلبك إلى المالك.",
        updatePassword: "لقد قمت بتحديث كلمة مرورك بنجاح. يمكنك الآن محاولة تسجيل الدخول!",
        confirmPasswordError: "كلمة المرور المؤكدة لا تتطابق مع كلمة المرور الجديدة.",
        passwordUpdateSuccess: "تم تحديث كلمة المرور بنجاح!",
        incorrectPassword: "كلمة المرور الحالية غير صحيحة. يُرجى المحاولة مرة أخرى.",
        userNotLogin: "أنت غير مسجل الدخول",
        currentPassword: "كلمة المرور الحالية غير صحيحة. يُرجى المحاولة مرة أخرى.",
        changePasswordError: "عذراً، حدث خطأ ما! يُرجى إعادة تحميل هذه الصفحة!",
        payoutStatusSuccess: "تم تحديث الحالة.",
        payoutStatusFailed: "فشل في تحديث الحالة.",
        invalidAddress: "يبدو أن عنوانك غير صالح، يرجى التحقق منه وتعديله!",
        failedPayout: "فشل الدفع للمالك. يُرجى المحاولة مرة أخرى باستخدام عملة مختلفة.",
        successPayout: "تم تحويل الدفعة إلى المالك بنجاح.",
        paymentToOwnerFailed: "فشل الدفع للمالك. يُرجى المحاولة مرة أخرى باستخدام عملة مختلفة.",
        serviceFeeUpdate: "تم تحديث رسوم الخدمة بنجاح!",
        serviceFeeUpdateFailed: "لقد فشل تحديث رسوم الخدمة!",
        deleteBlogDetails: "لقد تم حذف تفاصيل المدونة.",
        blogDeletionFailed: "فشل حذف المدونة!",
        updateBlogStatus: "تم تغيير الحالة بنجاح!",
        updateBlogStatusFailed: "فشل في تغيير الحالة",
        updateBlogSuccess: "تم تحديث تغييرات المدونة بنجاح!",
        deleteListing: "تم حذف الإعداد.",
        unableToDisableListSetting: "لا يُمكن حذف إعدادات القائمة. يجب أن يتوفر إعداد قائمة واحد على الأقل للسيارات.",
        unableToDeleteListSetting: "لا يُمكن حذف إعدادات القائمة. يتم استخدام إعدادات القائمة على العقار. يُرجى إزالة إعدادات القائمة على السيارة والمحاولة مرة أخرى.",
        listSettingModelUsed: "لا يُمكن حذف \"الماركة\". الغرض من \"الماركة\" هو إنشاء نموذج. يُرجى إزالة النموذج من السيارات والمحاولة مرة أخرى.",
        updateListSettings: "تم تحديث إعدادات القائمة بنجاح!",
        deletePopularLocation: "تم حذف الموقع الشهير بنجاح!",
        deletePopularLocationFailed: "فشلت عملية حذف المواقع الشهيرة!",
        locationStatusChanged: "تم تغيير حالة الموقع بنجاح!",
        locationStatusFailed: "فشل في تغيير حالة الموقع.",
        updateFindYourBlock: "تم تحديث التغييرات.",
        updateBannerSettings: "تم تحديث التغييرات بنجاح!",
        updateBannerSettingsFailed: "فشل تحديث إعدادات البانر",
        updateBanStatus: "تم تحديث حالة الحظر بنجاح.",
        selectBanOrUnBan: "يتعين عليك تحديد خيار الحظر أو إلغاء الحظر.",
        updateBanStatusFailed: "فشل في تحديث حالة الحظر.",
        paymentGatewayUpdated: "تم تحديث بوابة الدفع.",
        lastCheckoutRequired: "يجب تفعيل Checkout لبوابة دفع نشطة واحدة على الأقل.",
        paymentGatewayStatus: "يجب أن تكون هناك بوابة دفع واحدة نشطة على الأقل.",
        paymentGatewayStatusFailed: "فشل في تحديث الحالة.",
        updateStaticPageSuccess: "تم تحديث التغييرات.",
        updateStaticPageFailed: "فشل التحديث",
        updateStaticPageStatus: "فشل في تغيير الحالة",
        deleteUser: "تم حذف المستخدم بنجاح!",
        deleteUserFailed: "فشل حذف المستخدم!",
        updateWhyHost: "لماذا أصبحت مالكًا؟ لقد تم تحديث تغييرات الصفحة بنجاح!",
        noDataFound: "لم يتم العثور على أي بيانات في الملف",
        importCsvFileError: "عفواً، حدث خطأ ما، يرجى المحاولة مرة أخرى لاحقًا",
        invalidSpecialPrice: "السعر الخاص غير صالح.",
        invalidImageFile: "أنت تحاول تحميل ملف صورة غير صالح. يُرجى تحميل ملف الصورة بصيغ PNG وJPG وJPEG.",
        deleteReview: "تم حذف المراجعة بنجاح!",
        deleteReviewFailed: "فشلت عملية حذف المراجعة!",
        deleteAdminRole: "تم حذف دور المسؤول بنجاح!",
        deleteAdminUser: "تم حذف المستخدم الإداري بنجاح!",
        updateConfigSettings: "تم تحديث التكوينات بنجاح!",
        setDefaultBaseCurrency: "تم تعديل العملة الأساسية الافتراضية بنجاح",
        setDefaultBaseCurrencyFailed: "فشل في تعيين العملة الأساسية.",
        disableBaseCurrencyError: "عذرًا، لا يمكنك تعطيل العملة الأساسية الحالية. يُرجى تعيين عملة أساسية أخرى ثم تعطيل هذه العملة.",
        currencyStatusSuccess: "تم تغيير حالة العملة بنجاح!",
        currencyStatusFailed: "فشل في تغيير حالة العملة.",
        managePaymentCurrencySuccess: "تم تحديث تغييرات عملة الدفع بنجاح!",
        managePaymentCurrencyFailed: "فشل في تغيير حالة عملة الدفع.",
        removeRecommend: "تمت إزالة القائمة بنجاح من القائمة الموصى بها",
        addRecommendList: "تمت إضافة القائمة بنجاح إلى القائمة الموصى بها.",
        removeListingSuccess: "تمت إزالة القائمة بنجاح",
        unpublishListing: "لا يمكنك إلغاء النشر لأن لديك حجوزات أو استفسارات قادمة لهذا الإعلان.",
        userReviewUpdated: "تم تحديث المراجعة بنجاح.",
        checkTermsAndPolicy: "يرجى مراجعة الشروط وسياسة الخصوصية للمتابعة.",
        updatePopularLocation: "تم تحديث تغييرات الموقع بنجاح!",
        updatePopularLocationFailed: "فشل تحديث الموقع",
        addBlog: "لقد تمت إضافة المدونة بنجاح!",
        addBlogFailed: "عنوان الصفحة موجود بالفعل!",
        failedToCreateBlog: "فشل في الإنشاء",
        failedToUpdateBlog: "فشل تحديث المدونة",
        addedLocation: "تمت إضافة الموقع بنجاح!",
        addedLocationFailed: "فشل في الإنشاء",
        updateProfile: "لقد تم تحديث التغييرات الخاصة بك!",
        bookingFailed: "هذه التواريخ غير متاحة!",
        alreadyPerformedAction: "لقد قمت بتنفيذ هذا الإجراء بالفعل!",
        adminAccessDetails: "تم تغيير تفاصيل وصول المسؤول بنجاح!",
        listingUnPublish: "تم إلغاء نشر الإعلان أو حذفه من قِبل المالك/المسؤول. يُرجى المحاولة مرة أخرى.",
        removePhotosListing: "لا يمكنك إزالة الصور لأن هذا الإعلان يحتوي على حجوزات أو استفسارات قادمة!",
        confirmationEmail: "لقد أرسلنا رابط التأكيد إلى بريدك الإلكتروني.",
        sentEmailFailed: "عذرًا، حدث خطأ ما. يُرجى المحاولة مجددًا!",
        reservationCancelled: "لقد تم إلغاء حجزك.",
        tripCancelled: "لقد تم إلغاء رحلتك.",
        cancelReservationSuccess: "لقد تم تحديث حجزك بالفعل!",
        importCalendar: "بدأت عملية مزامنة التقويم الخاص بك!",
        calendarAlreadyExists: "لقد تم استيراد التقويم الخاص بك بالفعل!",
        invalidCalendar: "عنوان URL غير صالح، وفشل استيراد التقويم.",
        maximumUploadSize: "تم تجاوز الحد الأقصى لحجم التحميل!، حاول استخدام أصغر حجم للصورة",
        calendarRemoved: "لقد تمت إزالة التقويم الخاص بك!",
        deleteCalendarFailed: "لم يتم حذف تقويمك بنجاح. يُرجى المحاولة مرة أخرى.",
        payoutToHost: "تم تحويل مبلغ المطالبة إلى المضيف بنجاح!",
        paymentToHostFailed: "لقد فشلت عملية الدفع للمالك، يرجى المحاولة مرة أخرى باستخدام عملة مختلفة",
        paymentToHost: "لقد فشلت عملية الدفع للمالك، يرجى المحاولة مرة أخرى",
        importDuplicateItems: "يبدو أن هناك بعض العناصر المكررة في ملف الاستيراد، ولكن تم استيراد الإدخالات الجديدة بنجاح.",
        formError: "عذرًا، حدث خطأ ما. يُرجى المحاولة مجددًا!",
        updateBlockedDates: "عفواً! لا يُسمح لك بتحديث هذه التواريخ لأن بعضها محجوز.",
        removeBlockedDates: "هذه التواريخ غير متاحة!",
        uploadDocument: "تم تحميل الوثيقة بنجاح!",
        uploadDocumentError: "لقد حدث خطأ ما!",
        requiredError: "يبدو أنك تركت بعض الحقول المطلوبة فارغة. يُرجى تعبئتها.",
        updateListingError: "البيانات التي اخترتها غير متوفرة. يُرجى المحاولة مرة أخرى.",
        importSuccess: "نجاح! تم استيراد ملفك بنجاح.",
        addContent: "الرجاء إضافة المحتوى",
        addLocationImage: "الرجاء إضافة صورة الموقع",
        addMetaTitle: "الرجاء إضافة عنوان ميتا",
        addMetaDescription: "يرجى إضافة وصف التعريف",
        uploadPngImage: "أنت تحاول تحميل ملف صورة غير صالح. يُرجى تحميل ملف صورة بصيغة PNG.",
        csvFormat: "يرجى التأكد من أن تنسيق CSV يجب أن يحتوي على قسم Make",
        csvFormatError: "يرجى التأكد من أن تنسيق CSV يجب أن يتضمن العلامة التجارية والطراز.",
        uploadImage: "من فضلك قم بتحميل الصورة!",
        isAdmin: "لقد قمت بتسجيل الدخول كمسؤول، لا يمكنك القيام بهذا الإجراء!",
        checkUpcomingBooking: "لا يمكنك حذف هذا الإعلان لأنه يحتوي على حجوزات أو استفسارات قادمة.",
        checkAge: "عذرا، يجب أن يكون عمرك 18 سنة",
        checkDay: "حقل يوم الميلاد مفقود",
        checkMonth: "حقل شهر الميلاد مفقود",
        checkYear: "حقل سنة الميلاد مفقود",
        invalidDateOfBirth: "تاريخ الميلاد غير صحيح، الرجاء إدخال البيانات الصحيحة",
        emailAlreadyExist: "البريد الإلكتروني موجود بالفعل، يرجى تجربة عنوان بريد إلكتروني آخر!",
        loginUser: "لم يتم تسجيل دخولك، يرجى تسجيل الدخول والمحاولة مرة أخرى!",
        reloadPage: "عذراً، حدث خطأ ما! أعد تحميل هذه الصفحة وحاول مرة أخرى!",
        uploadCarPhoto: "تم تحميل صورة سيارتك بنجاح!",
        statusUpdate: "تم تحديث الحالة",
        claimAmount: "لقد تم استرداد مبلغ المطالبة بنجاح!",
        emailSent: "لقد تم إرسال بريدك الإلكتروني",
        documentRemoved: "لقد تم إزالة المستند بنجاح!",
        claimAmountUpdate: "تم تحديث مبلغ المطالبة بنجاح!",
        imageRemoved: "تمت إزالة الصورة بنجاح",
        phoneNumberVerify: "تم التحقق من رقم الهاتف بنجاح.",
        linkCopied: "تم نسخ الرابط بنجاح",
        updateWhyHostPage: "لماذا أصبحت إعدادات المالك تم تحديثها بنجاح!",
        updateWhyHostPageFailed: "فشل في تحديث سبب أن تصبح إعدادات المالك",
        alreadyReviewed: "لقد قمت بمراجعة هذه التحفظات بالفعل!",
        datesNotAvailable: "هذه التواريخ غير متاحة.",
        inCompleteZipCode: "الرمز البريدي الخاص بك غير مكتمل.",
        adminClaimModalError: "لقد حدث خطأ ما",
        footerSettingsUpdate: "تم تحديث إعدادات التذييل بنجاح!",
        footerSettingsUpdateFailed: "فشل تحديث إعدادات التذييل",
        blockSettingsFailed: "فشل تحديث إعدادات الكتلة الثابتة",
        blockSettingsUpdate: "تم تحديث إعدادات الكتلة الثابتة بنجاح!",
        updateAdminReview: "تم تحديث تفاصيل مراجعة المسؤول بنجاح!",
        submitAdminReview: "تم إرسال تفاصيل مراجعة الإدارة بنجاح!",
        updateUserReview: "تم تحديث تفاصيل مراجعة المستخدم بنجاح!",
        listIdNotAvailable: "معرف القائمة غير متاح!",
        adminReviewFailed: "لقد فشلت تغييراتك في مراجعة المسؤول!",
        alreadyEmailExist: "عفواً! عنوان البريد الإلكتروني هذا موجود بالفعل.",
        adminDetailsFailed: "لقد فشلت تغييراتك على تفاصيل وصول المسؤول!",
        settingsUpdate: "تم تحديث تغييرات الإعدادات بنجاح!",
        settingsUpdateFailed: "فشل تحديث الإعدادات",
        searchSettingsUpdate: "تم تحديث إعدادات البحث بنجاح!",
        searchSettingsUpdateFailed: "فشل تحديث إعدادات البحث",
        paymentSettingsUpdate: "تم تحديث إعدادات الدفع بنجاح!",
        paymentSettingsUpdateFailed: "فشل تحديث إعدادات الدفع",
        checkActiveListing: "تعذر تعطيل إعدادات القائمة. يجب تفعيل إعداد واحد على الأقل.",
        removeListSettings: "تعذر تعطيل إعداد القائمة. إعداد القائمة مُفعّل على السيارات. يُرجى إزالة إعداد القائمة من السيارات والمحاولة مرة أخرى.",
        removeModel: "لا يمكنك القيام بهذا الإجراء لأن العلامة التجارية المعنية مستخدمة في النموذج. يُرجى إزالته من صفحة النموذج والمتابعة.",
        listSettingsSuccess: "تم إنشاء إعدادات القائمة بنجاح!",
        listSettingsFailed: "اسم العنصر المضاف موجود بالفعل",
        paymentTransferToReenter: "تم تحويل الدفعة بنجاح إلى المستأجر",
        paymentTransferFailed: "لقد فشلت عملية الدفع للمستأجر، يرجى المحاولة مرة أخرى بعملة مختلفة",
        duplicateFiles: "يبدو أن ملف الاستيراد الخاص بك يحتوي على عناصر مكررة. يُرجى التحقق من الملف واستيراد العناصر الجديدة.",
        limitExceed: "تجاوز الحد! يُرجى استيراد البيانات حتى 3000 سجل.",
        invalidCurrency: "العملة التي اخترتها غير مدعومة من قِبل باي بال للدفع. يُرجى تغيير العملة ومحاولة الدفع مرة أخرى.",
        checkPaymentState: "بالنسبة لهذا الحجز، تم إكمال الدفع بالفعل",
        checkMakeDetails: "لم يتم العثور على أي تفاصيل عن الصنع للطراز",
        updateIOSSettings: "تم تحديث إعدادات التخطيط بنجاح!",
        adminUserLogged: "يبدو أنك سجّلت دخولك كمستخدم مسؤول. يُرجى تسجيل الخروج من لوحة إدارة الموقع والمحاولة مجددًا.",
        isPublished: "عفواً! لم تتمكن من التوصية بالقائمة غير المنشورة",
        securityDepositChange: "تم تحديث مبلغ التأمين! يُرجى التواصل مع الإدارة.",
        networkFailed: "أنت غير متصل بالإنترنت. يُرجى المحاولة لاحقًا.",
        offlineError: "أنت غير متصل بالإنترنت. يُرجى المحاولة لاحقًا.",
        minDayMaxDay: "لا يمكن أن يكون الحد الأدنى للأيام أكبر من الحد الأقصى للأيام",
        isAgreePhoneNumberError: "يرجى تحديد مربع التحقق من الرسائل النصية القصيرة وحفظ تفاصيلك.",
        updateEditProfile: "تم تحديث التغييرات بنجاح",
        deleteUserAccount: "لقد تم حذف حسابك بنجاح",
        deleteUserAccountFailed: "لا يمكنك حذف حسابك لأنه لديك حجوزات نشطة حاليًا",
        smtpActiveStatus: "تم تحديث الحالة بنجاح!",
        deleteSmtpData: "تم حذف سجل SMTP بنجاح.",
        deleteSmtpDataError: "لا يمكنك حذف بيانات اعتماد SMTP النشطة",
        payoutCurrencySuccess: "تم تحديث عملة الدفع بنجاح",
        payoutCurrencyFailed: "لا يُسمح لك بتحديث عملة الدفع المفضلة",
        cantDisablePayoutCurrency: "لا يمكنك تعطيل هذه العملة لأنها عملة الدفع المفضلة. يُرجى تحديد عملة أخرى كعملة دفع مفضلة قبل تعطيلها.",
        hostServiceFeeError: "عفواً! لا يُسمح لك بحجز هذه السيارة بسبب خطأ في التسعير. يُرجى التواصل مع الدعم لمزيد من المساعدة.",
        contactHostError: "لقد قمت بالفعل بالطلب في هذا التاريخ",
        catchError: `عفواً! حدث خطأ ما." ${error}`,
        addSmtpData: `تمت إضافة إعدادات SMTP بنجاح.`,
        documentManagementError: `حدث خطأ ما! ${error}`,
        addWishListGroupForm: error,
        stripePaymentGateway: `تم الوصول إلى ${error} Stripe بنجاح`,
        paypalPaymentGateway: `تم بنجاح ${error} في PayPal`,
        addUpdateAdminRole: `لقد تم تحديث دور المسؤول ${error ? 'تم تحديثه' : 'وأضاف'} بنجاح!`,
        adminRoleError: `عفواً، حدث خطأ ما"  ${error}`,
        addUpdateAdminUser: `لقد تم تحديث مستخدم المسؤول ${error ? 'تحديثه' : 'وأضاف'} بنجاح!`,
        adminUserError: `عفواً، حدث خطأ ما" ${error} `,
        listingFailed: `لقد فشل ${error}!`,
        deleteUserDetails: error,
        failedError: error,
        invalidError: error,
        commonSuccess: error,
        checkStatus: error,
        accountDeleteError: `تم حذف حسابك بنجاح. يُرجى التواصل مع الدعم الفني للحصول على المساعدة.`,
        accountBanError: `تم حظر حسابك من قِبل الإدارة. يُرجى التواصل مع الدعم الفني للمساعدة.`,
        mailTypeError: 'مطلوب عنوان الاستلام أو نوع القالب',
        filenameError: "اسم الملف غير موجود",
        fileRemoved: 'تمت إزالة الملفات بنجاح',
        fileNotRemoved: 'لم يتم حذف الملفات',
        otpError: "يرجى المحاولة مرة أخرى بعد دقيقتين لتلقي OTP جديد",
        cardError: 'عذرًا، حدث خطأ ما في بطاقتك. يرجى المحاولة مرة أخرى.',
        mobileLanguageSuccess: `تم تحديث لغة الهاتف المحمول بنجاح!`,
        webLanguageSuccess: `تم تحديث لغة الويب بنجاح!`,
        mobileLanguageError: `عفواً! حدث خطأ ما. فشل تحديث لغة الهاتف!`,
        mobileLanguageDuplicateError: `عذرًا! حدث خطأ ما. فشل تحديث لغة ${error == 'web' ? 'الويب' : 'الجوال'}! تم العثور على سجلات مكررة`,
        mobileLanguageEmptyError: `عذرًا! حدث خطأ ما. فشل تحديث لغة ${error == 'web' ? 'الويب' : 'الجوال'}! تم العثور على سجلات فارغة`,
        mobileLanguageRegexError: `عذرًا! حدث خطأ ما. فشل تحديث لغة ${error == 'web' ? 'الويب' : 'الجوال'}! السجلات لا تطابق أحرفًا أبجدية`,
        documentsRejected: `لقد تم رفض الوثائق!`,
        settingUpdateSuccess: `تم تطبيق تغييرات إعدادات الموقع بنجاح`,
        demoWarning: `عذراً، لا يُسمح لك بتغيير أو إزالة معلومات العرض التوضيحي.`,
        disableDemo: `تم تعطيل هذا الإجراء على الموقع التجريبي.`,
        reportTypeDeleteError: 'لا يُمكن حذف هذا النوع من التقارير. يجب أن يبقى نوع تقرير واحد على الأقل في قسم "نوع التقرير".',
        invalidReportId: 'معرف التقرير غير متوفر',
        reportTypeAddSuccess: 'تمت إضافة نوع التقرير بنجاح',
        reportTypeUpdateSuccess: 'تم تحديث نوع التقرير بنجاح',
        reportTypeDeleteSuccess: 'تم حذف نوع التقرير بنجاح',
        notReportContent: 'يرجى تحديد نوع تقرير واحد على الأقل قبل الإرسال.',
        invalidEmail: 'عنوان البريد الإلكتروني الذي أدخلته غير صحيح. يُرجى التحقق والمحاولة مرة أخرى.',
        updateSmtpData: `تم تحديث إعدادات SMTP بنجاح.`,
        listPublish: `لقد تم نشر قائمتك بنجاح!`,
        listUnPublish: `لقد تم إلغاء نشر قوائمك بنجاح!`,
        promoDeletedSuccess: 'تم حذف الرمز الترويجي بنجاح',
        promoCodeUpdated: 'تم تحديث تفاصيل رمز القسيمة بنجاح',
        promoDeletedSuccess: 'تم حذف رمز القسيمة بنجاح',
        promoCodeAddedSuccess: 'تمت إضافة رمز القسيمة بنجاح',
        promoCodeExist: 'أُووبس! يبدو أن هذا الرمز الترويجي قيد الاستخدام بالفعل. يرجى المحاولة مرة أخرى باستخدام اسم رمز ترويجي مختلف.',
        usedPromo: 'يبدو أن رمز العرض الترويجي الذي أدخلته قد تم استخدامه لحجز آخر. يُرجى استخدام رمز ترويجي آخر.',
        invalidPromo: 'الرجاء إدخال رمز ترويجي صالح للحصول على خصم.',
        updateCurrencyError: 'لا يمكن إزالة هذه العملة أو تعطيلها لأنه يجب أن تظل عملة واحدة على الأقل نشطة.',
        servicePlanAdd: "تمت إضافة خطة الخدمة بنجاح",
        servicePlanUpdate: "تم تحديث خطة الخدمة بنجاح",
        deleteServicePlansSuccess: "تم حذف خطة الخدمة بنجاح",
        servicePlanImageError: "لا يمكنك حفظ خطة الخدمة دون إضافة الصورة. يرجى تحميل صورة والمضي قدما.",
        servicePlanStatusSuccess: "تم تحديث حالة خطة الخدمة بنجاح",
        mobileSetDefaultError: 'لا يمكنك تعيين لغة غير نشطة كلغة افتراضية.',
        mobileSetInActiveError: 'لا يمكن تعطيل اللغة الافتراضية أثناء تعيينها كلغة افتراضية.',
        existAdminUser: `أُووبس! عنوان البريد الإلكتروني هذا موجود بالفعل.`,
        ContactHostSameTimeErrorForAI: `خطأ، يجب عليك اختيار وقت انتهاء مختلف للمتابعة.`,
        paymentActiveError: 'لا يمكنك تعطيل هذا الخيار الآن لأن بعض المستخدمين يستخدمون هذه الميزة بنشاط.',
        duplicateOrder: `لا يمكن استخدام رقم ترتيب مكرر. يرجى المحاولة مرة أخرى باستخدام رقم ترتيب مختلف.`,
        keyValueRequiredError: "كل من المفتاح والقيمة مطلوبان لجميع الإدخالات.",
        invalidCsvFileType: "الرجاء اختيار ملف CSV فقط.",
        invalidCsvColumns: "الورقة يجب أن تحتوي على مفتاحين وقيم فقط.",
        emptyCsvSheet: "الورقة فارغة أو لا تحتوي على صفوف مفتاح قيمة.",
        downloadLanguageCsv: "تحميل CSV",
        siteAdminPushNotification: "تم إرسال إشعار الدفع بنجاح",
        webLanguageError: `عذراً! حدث خطأ ما. فشل تحديث لغة الموقع الإلكتروني!`,
        promoCodeCalculation: 'لا يمكن تطبيق الرموز الترويجية عند تطبيق خصم أسبوعي أو شهري على هذا الحجز.',
        sendSMTPEmail: 'أُووبس! حدث خطأ ما. غير قادر على إرسال البريد الإلكتروني.',
        duplicateRequestError: 'تم اكتشاف طلب مكرر. يرجى الانتظار لحظة قبل المحاولة مرة أخرى.',
        tooManyRequestsError: 'عدد الطلبات كبير جداً. يرجى المحاولة مرة أخرى بعد بضع دقائق.',
        invalidRecaptchaError: 'reCAPTCHA أو الطلب غير صحيح. يرجى التحديث والمحاولة مرة أخرى.',
        chooseLanguageError: 'يرجى اختيار لغة',
        alert: 'تنبيه!',
        demoEmailWarning: 'هذا الإجراء غير مسموح به على الموقع التجريبي.',
        servicePlanDisabledWarning: 'الميزة التي تحاول تجربتها غير متوفرة في الوقت الحالي. يرجى الاتصال بالدعم لمزيد من المعلومات.',
        unEnableServicePlan: 'أُووبس! غير قادر على إلغاء تنشيط خطة الخدمة لأنها قيد الاستخدام حاليًا بواسطة مستخدم واحد.',
        inspectionWindowClosed: "عملية التسجيل عند الاستلام أو عند التسليم غير متاحة لهذا الحجز في الوقت الحالي.",
        inspectionLocked: "تم اعتماد هذا السجل من الطرفين ولا يمكن تعديله بعد الآن.",
        inspectionVersionConflict: "توجد نسخة أحدث. يرجى مراجعة آخر نسخة قبل المتابعة.",
        notReservationParty: "يمكن لمالك السيارة أو المستأجر فقط في هذا الحجز القيام بذلك.",
        mileageDecreasing: "لا يمكن أن تكون قراءة العداد عند الإرجاع أقل من قراءته عند الاستلام.",
        photoLimitReached: "تم الوصول إلى الحد الأقصى لعدد الصور.",
        invalidFuelLevel: "يرجى اختيار مستوى وقود صحيح.",
        decisionMotiveRequired: "السبب مطلوب لهذا القرار.",
        disputeAlreadyOpen: "يوجد نزاع مفتوح بالفعل لهذا الحجز.",
        inspectionDisabled: "ميزة التسجيل عند الاستلام والتسليم غير متاحة في الوقت الحالي.",
        inspectionActionNotAllowed: "هذا الإجراء غير مسموح به في الحالة الحالية.",
        inspectionNotFound: "لم يتم العثور على تسجيل استلام أو تسليم لهذا الحجز.",
        inspectionAlreadyValidated: "لقد اعتمدت هذه النسخة بالفعل.",
        invalidMileage: "يرجى إدخال قراءة عداد صحيحة (عدد صحيح، 0 أو أكثر).",
        invalidGeneralState: "يرجى اختيار الحالة العامة للسيارة.",
        commentTooLong: "النص طويل جدًا (500 حرف كحد أقصى).",
        invalidChecklist: "يرجى استكمال قائمة الوثائق والتجهيزات.",
        damageAnswerRequired: "يرجى الإشارة إلى ما إذا كانت السيارة مُرجَعة دون أضرار.",
        damageDescriptionRequired: "يرجى وصف الضرر.",
        photoMinNotReached: "يرجى إضافة مزيد من الصور قبل المتابعة.",
        invalidPhoto: "صورة واحدة أو أكثر غير صالحة لهذا السجل.",
        noRecordsFound: "عذرا، لم يتم العثور على أي سجلات!",
        invalidReservationId: "عذراً، لقد قمت بتوفير معرف حجز غير صالح لهذا المستخدم.",
        invalidData: 'عفواً! حدث خطأ ما. يُرجى تزويدنا بالبيانات.',
        loginAccount: "يرجى تسجيل الدخول بحسابك ومتابعة الحجز الخاص بك!",
        checkUserStatus: "عفواً! يبدو أن حسابك معطل حالياً. يُرجى التواصل مع فريق الدعم.",
        findAccount: "عفواً! لم نتمكن من العثور على حسابك. يُرجى التواصل مع الدعم للمساعدة.",
        invalidRetainedAmount: "يرجى إدخال مبلغ محتجز صالح (أكبر من 0 وأقل من مبلغ الضمان).",
        invalidRequestedAmount: "يرجى إدخال مبلغ صالح أكبر من 0.",
        attachmentLinked: "هذا المستند جزء من ملف النزاع ولم يعد من الممكن حذفه.",
        fileTooLarge: "الملف كبير جداً.",
        unsupportedFileType: "نوع الملف هذا غير مقبول.",
        reportingInvalidPeriod: "فترة غير صالحة. اختر اليوم أو 7 أيام أو 30 يومًا أو هذه السنة أو تواريخ مخصصة.",
        reportingInvalidDate: "يرجى إدخال تاريخي بداية ونهاية صالحين (YYYY-MM-DD).",
        reportingEndBeforeStart: "يجب ألا يسبق تاريخ النهاية تاريخ البداية.",
        reportingPeriodTooLong: "لا يمكن أن تتجاوز الفترة 366 يومًا.",
        reportingInvalidGranularity: "دقة الرسم البياني غير صالحة. اختر يومًا أو أسبوعًا أو شهرًا أو سنة.",
        reportingInvalidTab: "تبويب الإيرادات غير صالح. اختر الكل أو القادمة أو قيد التحويل أو المحوّلة.",
        reportingListingNotFound: "لم يتم العثور على هذه السيارة ضمن إعلاناتك.",
        reportingCurrencyRateMissing: "سعر الصرف المطلوب لهذا التقرير غير متوفر. يرجى التواصل مع الدعم.",
        reportingInvalidCurrency: "عملة العرض غير صالحة.",
        reportingCsvStartDate: "تاريخ البداية",
        reportingCsvReservation: "الحجز",
        reportingCsvVehicle: "السيارة",
        reportingCsvTypes: "الأنواع",
        reportingCsvGross: "المبلغ الإجمالي",
        reportingCsvNet: "صافي الإيراد",
        reportingCsvStatus: "الحالة",
        reportingCsvPaymentMethod: "طريقة الدفع",
        reportingCsvReference: "المرجع",
        reportingCsvTypeRental: "الإيجار",
        reportingCsvTypeOptions: "الخيارات",
        reportingCsvTypeDelivery: "التسليم",
        reportingCsvStatusUpcoming: "قادم",
        reportingCsvStatusPending: "قيد التحويل",
        reportingCsvStatusPaid: "تم التحويل",
        reportingCsvStatusCancelled: "ملغى",
        reportingCsvTruncated: `التصدير محدود بأول ${error} سطرًا. قلّص الفترة أو عوامل التصفية لتصدير الباقي.`,
    }
    return message[errorcode];
}
export default errorMessage;
